export default __webpack_public_path__ + "static/media/investing_pref_04.a91a1449.png";